import React from 'react';

import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import {FormInputDatePicker, FormInputCheckbox, FormTextarea, SmartErrorDiv} from "../../../ReactHookForm/FormComponents";
import HookSubFormStarFunding from "root/Base/HookFormComponents/Education/HookSubFormStarFunding";
import DropdownLocalAuthorities from "root/ReactHookForm/ui/DropdownLocalAuthorities";

const HookSubFormSEND = ({control, register, watch, formErrors, sectionName, readOnly, isPost16}) =>
{
    const isSENK = watch(sectionName + '.sen_k_flag')
    const isEHCP = watch(sectionName + '.ehcp_flag')

    const disableEHCP = isSENK || readOnly;
    const disableSENK = isEHCP || readOnly;

    const controlProps = {
        control: control,
        register: register,
        watch: watch,
        formErrors: formErrors,
        readOnly: readOnly
    }

    const validateEHCPLACode = (val) =>
    {
        if (val === null)
        {
            return "Please select a Local Authority for this ECHP";
        }
    }

    return (
        <FieldsetContainer title='SEND'>

            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={disableSENK} label='Is the pupil on SEND K Support' sectionName={sectionName} name={'sen_k_flag'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            { /* <BootstrapRow>
                { isSENK === true && <BootstrapCol width={12}>
                    <FormTextarea readOnly={disableSENK} label='Details?' sectionName={sectionName} name={'senk_details'} register={register} required={true} maxLength={2000} formErrors={formErrors}/>
                </BootstrapCol> }
            </BootstrapRow> */ }

            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={disableEHCP} label='Does the pupil have an Education Health and Care Plan (EHCP)' sectionName={sectionName} name={'ehcp_flag'}  register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            <BootstrapRow>
                { isEHCP === true && <BootstrapCol width={6}>
                    <FormTextarea readOnly={disableEHCP} label='What Are the Needs?' sectionName={sectionName} name={'needs'} register={register} required={true} maxLength={2000} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEHCP === false && <BootstrapCol width={6}></BootstrapCol> }

                { isEHCP === true &&  <BootstrapCol width={6}>
                    <FormTextarea readOnly={disableEHCP} label='What is the provision?' sectionName={sectionName} name={'provision'} register={register} required={true} maxLength={2000} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEHCP === false && <BootstrapCol width={6}></BootstrapCol> }
            </BootstrapRow>

            <BootstrapRow>
                { isEHCP === true &&  <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={disableEHCP} label='Date of First EHCP' sectionName={sectionName} name={'dmy_statement_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEHCP === false && <BootstrapCol width={6}></BootstrapCol> }

                { isEHCP === true && <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={disableEHCP} label='Date of Last Review' sectionName={sectionName} name={'dmy_last_review_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol> }
                { isEHCP === false && <BootstrapCol width={6}></BootstrapCol> }

            </BootstrapRow>

            <BootstrapRow>
                {isEHCP === true && <BootstrapCol width={6}>
                    <label className='col-form-label'>Authority Responsible for EHCP</label>
                    <DropdownLocalAuthorities readOnly={disableEHCP} control={control} name={sectionName + '.ehcp_la_code'} register={register} required={true} formErrors={formErrors} rules={{validate: validateEHCPLACode}}/>
                    <SmartErrorDiv sectionName={sectionName}  name={'ehcp_la_code'} maxLength={200} formErrors={formErrors} />
                </BootstrapCol>}
            </BootstrapRow>

        </FieldsetContainer>
    )
}


export default HookSubFormSEND;
